import React from 'react';
import _ from 'lodash';
import { HeaderNoteWrapper } from './index.style';
export default function HeaderNote(_ref) {
  var {
    values
  } = _ref;
  return /*#__PURE__*/React.createElement(HeaderNoteWrapper, null, _.size(values), " Selected");
}